import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { WaveformLogo } from '../../components/icons';
import { Button, ThemeToggle } from '../../components/ui';
import './Welcome.css';

const encouragements = [
  "Your next masterpiece is waiting.",
  "Every artist was first an amateur.",
  "Progress, not perfection.",
  "Today is a good day to create.",
  "Your ideas deserve to exist.",
];

export const Welcome: React.FC = () => {
  const [encouragement, setEncouragement] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setEncouragement(encouragements[Math.floor(Math.random() * encouragements.length)]);
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className="welcome-screen">
      {/* Animated background */}
      <div className="welcome-bg">
        <div className="welcome-bg__gradient" />
        <div className="welcome-bg__orb welcome-bg__orb--1" />
        <div className="welcome-bg__orb welcome-bg__orb--2" />
        <div className="welcome-bg__orb welcome-bg__orb--3" />
        <div className="welcome-bg__stars">
          {[...Array(12)].map((_, i) => (
            <div key={i} className={`star star--${i + 1}`} />
          ))}
        </div>
      </div>

      <div className={`welcome-content ${isVisible ? 'welcome-content--visible' : ''}`}>
        {/* Theme toggle in corner */}
        <div className="welcome-theme-toggle">
          <ThemeToggle />
        </div>

        {/* Logo with warmth */}
        <div className="welcome-header">
          <div className="welcome-logo">
            <WaveformLogo size={56} />
            <h1 className="welcome-logo__text">Kadans</h1>
          </div>
          <p className="welcome-encouragement">{encouragement}</p>
        </div>

        {/* Illustration - More expressive */}
        <div className="welcome-illustration">
          <div className="welcome-illustration__glow" />
          <div className="welcome-illustration__person">
            <div className="person__head" />
            <div className="person__body" />
            <div className="person__arm person__arm--left" />
            <div className="person__arm person__arm--right" />
          </div>
          <div className="welcome-illustration__notes">
            <span className="note note--1">&#9834;</span>
            <span className="note note--2">&#9833;</span>
            <span className="note note--3">&#10022;</span>
            <span className="note note--4">&#9734;</span>
          </div>
          <div className="welcome-illustration__brush">
            <div className="brush__stroke brush__stroke--1" />
            <div className="brush__stroke brush__stroke--2" />
            <div className="brush__stroke brush__stroke--3" />
          </div>
        </div>

        {/* Emotional tagline */}
        <div className="welcome-text">
          <h2 className="welcome-tagline">
            Find your <span className="welcome-tagline__highlight">creative rhythm</span>
          </h2>
          <p className="welcome-subtitle">
            A gentle space for artists who have big dreams<br />
            and too many unfinished projects.
          </p>
          <p className="welcome-promise">
            No guilt. No pressure. Just progress.
          </p>
        </div>

        {/* Actions with personality */}
        <div className="welcome-actions">
          <Link to="/dashboard" className="welcome-cta-link">
            <Button fullWidth size="lg" className="welcome-cta">
              <span className="welcome-cta__text">Begin Your Journey</span>
              <span className="welcome-cta__arrow">&#10132;</span>
            </Button>
          </Link>
          <Link to="/login" className="welcome-signin">
            Welcome back? <span className="welcome-signin__link">Sign in here</span>
          </Link>
        </div>

        {/* Trust indicators */}
        <div className="welcome-trust">
          <div className="welcome-trust__item">
            <span className="welcome-trust__icon">&#10003;</span>
            <span>Free forever plan</span>
          </div>
          <div className="welcome-trust__item">
            <span className="welcome-trust__icon">&#9825;</span>
            <span>Built for artists</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
